import styled from "styled-components";
import { breakpoints, sizes } from "styles";

export const TestimonialsSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 100px;
  gap: 42px;
  background: #ecf6ff;

  @media ${breakpoints.mobile} {
    padding: 32px 16px;
    gap: 28px;
  }
`;

export const TestimonialsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 42px;
  max-width: ${sizes.containerWidth};
  width: 100%;
  margin: 0 auto;

  @media ${breakpoints.mobile} {
    gap: 28px;
  }
`;

export const TestimonialsTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 30px;
  line-height: 42px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;

  @media ${breakpoints.mobile} {
    font-size: 22px;
    line-height: 30px;
  }
`;

export const TestimonialsCardsRow = styled.div`
  display: flex;
  gap: 28px;
  align-items: stretch;
  justify-content: center;
  width: 100%;

  @media ${breakpoints.mobile} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const TestimonialCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0px 0px 68px 0px rgba(26, 72, 208, 0.12);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: space-between;
  overflow: clip;
  flex: 1;
  min-width: 0;
`;

export const TestimonialText = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #2c2c31;
  margin: 0;
`;

export const TestimonialAuthor = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

export const TestimonialAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
`;

export const TestimonialAuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TestimonialAuthorName = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;
`;

export const TestimonialAuthorClass = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;
`;

export const GuaranteeBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 37px 94px;
  background: #fff3a8;
  border-radius: 16px;
  width: fit-content;
  margin: 0 auto;

  @media ${breakpoints.mobile} {
    flex-direction: column;
    align-items: center;
    padding: 24px;
    gap: 16px;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
`;

export const GuaranteeBadge = styled.div`
  width: 122px;
  height: 118px;
  flex-shrink: 0;
  position: relative;
`;

export const GuaranteeTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media ${breakpoints.mobile} {
    align-items: center;
  }
`;

export const GuaranteeHeading = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: 36px;
  line-height: 40px;
  color: ${({ theme }) => theme.colors.black["100"]};

  p {
    margin: 0;
  }

  @media ${breakpoints.mobile} {
    font-size: 20px;
    line-height: 28px;
    text-align: center;
  }
`;

export const GuaranteeSubtext = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 700;
  font-size: 15px;
  line-height: 30px;
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;

  a {
    color: #1e5af6;
    text-decoration: none;
  }

  @media ${breakpoints.mobile} {
    font-size: 15px;
    line-height: 15px;
    text-align: center;
  }
`;
